import React, { useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import Layout from './layout';
import formService from '../../../services/formService';
import CourseObj from '../../../objects/courseType';

const FormItem = Form.Item;
const Option = Select.Option;

const defaultRules = [
  {
    required: true,
    message: '上课类型不能为空',
  },
];

const sortCourseTypes = (items) =>
  items.sort((a, b) => Number(a.weight || 0) - Number(b.weight || 0));

const CourseTypeFormItem = (props) => {
  const [courseTypes, setCourseTypes] = useState(CourseObj.courseType);
  let layouts = props.formItemLayout
    ? props.formItemLayout
    : Layout.formItemLayout;
  let rules = props.rules ? props.rules : defaultRules;

  useEffect(() => {
    formService
      .queryCourseType()
      .then((res) => {
        const data = sortCourseTypes(res.data || []);
        localStorage.setItem('COURSE_TYPE_LIST', JSON.stringify(data));
        setCourseTypes(data);
      })
      .catch(() => setCourseTypes(CourseObj.courseType));
  }, []);

  return (
    <FormItem label='上课类型' {...layouts} name='courseType' rules={rules}>
      {
        <Select
          mode='multiple'
          showSearch
          optionFilterProp='children'
          filterOption={(input, option) =>
            String(option.children).toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          style={props.itemStyle}
          allowClear
        >
          {courseTypes.map((courseType) => (
            <Option key={courseType.type} value={courseType.type}>
              {courseType.name}
            </Option>
          ))}
        </Select>
      }
    </FormItem>
  );
};

export default CourseTypeFormItem;
